/**
 * Converts a base64 dataURI to raw binary data held in a JS Blob.
 *
 * Source: http://stackoverflow.com/questions/12168909/blob-from-dataurl/12300351#12300351
 */

function dataURIToBlob(dataURI: string, name: string): Blob & {name: string} {
  const byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  const blob: Blob & {name?: string} = new Blob([ab], {type: mimeString});
  blob.name = name;
  return blob as Blob & {name: string};
}

export default dataURIToBlob;
